import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "import",
  "use": "import-usage",
  "viewBox": "0 0 58 58.01",
  "content": "<symbol viewBox=\"0 0 58 58.01\" id=\"import\"><title>资源 1</title><g id=\"import_图层_2\" data-name=\"图层 2\"><g id=\"import_图层_1-2\" data-name=\"图层 1\"><path d=\"M56.19,29H31.57l4.59-4.59h0a1.82,1.82,0,1,0-2.57-2.57L26,29.47l-.07.07a1.82,1.82,0,0,0,0,2.56l.07.07,7.61,7.61a1.82,1.82,0,1,0,2.57-2.57l-4.59-4.59H56.19a1.81,1.81,0,1,0,0-3.61Z\" /><path d=\"M47.13,1.82A1.81,1.81,0,0,0,45.32,0H15.17a1.8,1.8,0,0,0-1.42.53L.69,13.62l-.14.16A1.81,1.81,0,0,0,0,15.08V56.2A1.81,1.81,0,0,0,1.81,58h43.5a1.82,1.82,0,0,0,1.81-1.81V45.32a1.82,1.82,0,0,0-3.63,0v9.06H3.62V18.14H16.31a1.81,1.81,0,0,0,1.81-1.81V3.63H43.5v12.7a1.82,1.82,0,1,0,3.63,0ZM14.5,14.51H4.93L14.5,4.94Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/import.svg
// module id = aYs0
// module chunks = 264